import { VfsStateInterface } from "./vfs.model";

export class SetVfsStatus {
  static readonly type = '[SetVfsStatus]: action';

  constructor(public payload: VfsStateInterface) { }
}
